import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.css']
})
export class CustomHeaderComponent implements OnInit {
  searching: string = '';
  hiddenElement: Boolean = false;
  isLoggedUser!: boolean;
  user : any = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : {};

  constructor(private router: Router){}

  options!: MenuItem[];
  activeOption!: MenuItem;

  optionsPop!: MenuModule[] ;
  activeOptionPop!: MenuModule;

  ngOnInit(): void {
    this.isLoggedUser = localStorage.getItem('token') ? true : false;
    this.options = [
      {
        label: 'INICIO',
        queryParams:{ url: '/' }
      },
      {
        label: 'CATÁLOGO DE PRODUCTOS',
        queryParams:{ url: '/product-catalog' }
      },
      {
        label: 'EVENTOS',
        queryParams:{ url: '/events' }
      },
      {
        label: 'NOTICIAS',
        queryParams:{ url: '/news' }
      },
      {
        label: 'MI CUENTA',
        queryParams:{ url: '/account' },
        command: () => {
          localStorage.setItem('goToCount', 'true');
        }
      }
    ];

    this.optionsPop = [
      {
        label: 'INICIO',
        routerLink: '/'
      },
      {
        label: 'CATÁLOGO DE PRODUCTOS',
        routerLink: '/product-catalog'
      },
      {
        label: 'EVENTOS',
        routerLink: '/events'
      },
      {
        label: 'NOTICIAS',
        routerLink: '/news'
      },
      {
        label: 'MI CUENTA',
         routerLink: '/account',
         command: () => {
          localStorage.setItem('goToCount', 'true');
         }
      }
    ];

    this.activeOption = this.options.find((option) => option.queryParams!['url'] == this.router.url)!;
  }

  onActiveItemChange(event: any){
    const url = event?.queryParams?.url ?? null;

    if (url) {
      this.router.navigate([url]);
    }
  }

  search(query: string){
    if(query === '') return;
    this.searching = '';
    this.router.navigate(['product-catalog'], {
      queryParams: {search: query },
      skipLocationChange: false
    });
  }

  goToLogin() {
    this.router.navigate(['auth/login']);
  }

  logOut() {
    this.isLoggedUser = false;
    localStorage.clear();
    window.location.reload();
  }
}
